import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import {
    Box, Divider, Typography, Container, Fab,
    Paper
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

import CustomChip from '../../utils/components/CustomChip';

function Servicios(props) {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [servicios, setServicios] = useState([]);

    useEffect(() => {
        if (!['Admin', 'Vendedor', 'Ayudante', 'Vendedor2'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
    }, [auth])

    const getUuid = () => { return uuidv4() };

    useEffect(() => {
        setServicios([
            {
                _id: '44147a44-6ae3-4652-95a6-1bb0306b69f4',
                nombre: 'Envío', clave: `${props.configs.prefijo}-S001`, precioUnitario: 200, costoUnitario: 200,
                cantidad: 1, descripcion: 'Envío', imagen: '', printImage: false, categoria: 'Envío', porcentajeDescuento: 0
            },
            {
                _id: '0c2d13c9-28cc-4e1f-ae13-eec2106a21a3',
                nombre: 'Producto No Listado', clave: `${props.configs.prefijo}-S007`, precioUnitario: 200, costoUnitario: 100,
                cantidad: 1, descripcion: 'Producto No Listado', imagen: '', printImage: false, categoria: '', porcentajeDescuento: 0
            },
            {
                _id: '44147a44-6ae3-4652-95a6-drs0401eo25l',
                nombre: 'Diseño', clave: `${props.configs.prefijo}-S008`, precioUnitario: 1750, costoUnitario: 2010,
                cantidad: 1, descripcion: 'Diseño', imagen: '', printImage: false, categoria: 'Diseño', porcentajeDescuento: 0
            },
            {
                _id: 'b6207b64-cb07-4099-8b23-1e34e1fe0ea4',
                nombre: 'Fabricación', clave: `${props.configs.prefijo}-S002`, precioUnitario: 200, costoUnitario: 100,
                cantidad: 1, descripcion: 'Fabricación', imagen: '', printImage: false, categoria: 'Fabricación', porcentajeDescuento: 0
            },
            {
                _id: '12fd050c-0a54-4cce-a230-015bc6acc579',
                nombre: 'Reparación', clave: `${props.configs.prefijo}-S004`, precioUnitario: 200, costoUnitario: 100,
                cantidad: 1, descripcion: 'Reparación', imagen: '', printImage: false, categoria: 'Reparación', porcentajeDescuento: 0
            },
            {
                _id: 'dffd1e43-2450-44ed-a61e-eed894db3566',
                nombre: 'Mantenimiento', clave: `${props.configs.prefijo}-S005`, precioUnitario: 200, costoUnitario: 100,
                cantidad: 1, descripcion: 'Mantenimiento', imagen: '', printImage: false, categoria: 'Mantenimiento', porcentajeDescuento: 0
            },
            {
                _id: '20a80ba2-9971-4d4b-98bb-9d833cb7e8bd',
                nombre: 'Modificación', clave: `${props.configs.prefijo}-S003`, precioUnitario: 200, costoUnitario: 100,
                cantidad: 1, descripcion: 'Modificación', imagen: '', printImage: false, categoria: 'Modificación', porcentajeDescuento: 0
            },
            {
                _id: 'a0419254-d4c9-4bfe-940d-d09484581524',
                nombre: 'Otro', clave: `${props.configs.prefijo}-S006`, precioUnitario: 200, costoUnitario: 100,
                cantidad: 1, descripcion: 'Otro', imagen: '', printImage: false, categoria: '', porcentajeDescuento: 0
            },

        ])
    }, [props])

    const handleAddService = (id) => {
        const product = servicios.find(product => product._id === id);
        product._id = getUuid();
        props.onAddService(product);
    }

    const renderProducts = () => {
        return (
            <>
                <DataGrid
                    rows={servicios}
                    density='comfortable'
                    sx={{ height: 'auto', '& .MuiDataGrid-row': { backgroundColor: 'comp.tableBg', color: 'text.primary', height: 'auto' }, '& .MuiDataGrid-columnHeader': { backgroundColor: 'comp.tableHeaderBg', color: 'text.primary' } }}
                    getRowId={(row) => row._id}
                    onCellDoubleClick={(row) => handleAddService(row.id)}
                    columns={[
                        { field: 'clave', headerName: 'Clave', minWidth: 200, flex: 1 },
                        { field: 'nombre', headerName: 'Servicio', minWidth: 200, flex: 1 },
                        { field: 'cantidad', headerName: 'Existencia', type: 'number' },
                        {
                            field: 'id',
                            headerName: 'Acción',
                            headerAlign: 'center',
                            align: 'center',
                            sortable: false,
                            filterable: false,
                            disableColumnMenu: true,
                            renderCell: (row) => (
                                <Fab variant='contained' color='primary' size='small' onClick={() => handleAddService(row.id)}>
                                    <i className='fad fa-plus-circle fa-2x'></i>
                                </Fab>
                            )
                        },
                    ]}
                />

            </>
        )
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px', padding: '0px 8px' }}>
            <Paper sx={{ padding: '24px 0px' }} elevation={3}>
                <Container maxWidth='xxl' style={{ padding: '8px' }}>
                    <Box className='text-center' >
                        <Typography variant='h5' style={{ fontWeight: 700 }}>Servicios</Typography>
                    </Box>

                    <Divider className='my-3' textAlign="left">
                        <CustomChip variant='outlined' estatus='AUTORIZADO' label='Selecciona uno o mas servicios' className='text-bold' />
                    </Divider>

                    {servicios.length > 0 ? renderProducts() : <Typography variant='h6' className='text-center' style={{ fontWeight: 700 }}>No se encontraron servicios</Typography>}
                </Container>
            </Paper>
        </Container>
    );
}

export default Servicios;